import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { CartFunnelSelectBlockConfig } from '@front-platform/content-builder';
import { cartFunnelSelectBlockResolveConfig } from '@front-platform/content-builder';
import { Component, OnInit, input } from '@angular/core';
import { CartFunnelStoreDispatcher } from '@common/dispatchers/cart-funnel.dispatcher';
import { ContentStoreSelector } from '@common/selectors/content.selector';
export interface CartFunnelSelectBlockRuntimeConfig {
  'block_id'?: string;
  'form_id'?: string;
}

export type CartFunnelSelectBlockConfigInput = Partial<
  Omit<CartFunnelSelectBlockConfig, keyof CartFunnelSelectBlockRuntimeConfig> &
    CartFunnelSelectBlockRuntimeConfig
>;
export type CartFunnelSelectBlockResolvedConfig = Omit<
  CartFunnelSelectBlockConfig,
  keyof CartFunnelSelectBlockRuntimeConfig
> &
  Partial<CartFunnelSelectBlockRuntimeConfig>;
export interface CartFunnelSelectBlockContract extends ConfigComponentContract<
  CartFunnelSelectBlockConfigInput,
  CartFunnelSelectBlockResolvedConfig
> {}

@Component({
  selector: 'app-cart-funnel-select-block',
  template: `
    <div class="pt-4">
      <label class="mb-3 mt-5 block font-accent text-md font-bold md:mt-6">
        {{ title }}
        @if (required) {
          <span>&#42;</span>
        }
      </label>
      <label class="block max-w-screen-sm">
        <select
          class="form-select mt-1 block w-full border-neutral-300 bg-neutral-50 py-2.5 pl-4 font-base text-base font-normal"
          [ngClass]="
            radiusType === 'SM'
              ? 'rounded-sm'
              : radiusType === 'MD'
                ? 'rounded-md'
                : radiusType === 'LG'
                  ? 'rounded-lg'
                  : 'rounded-full'
          "
          [(ngModel)]="selectedItem"
          (change)="onValueChange(selectedItem)"
        >
          @if (placeholder) {
            <option
              [value]="'0'"
              disabled
              selected
            >
              {{ placeholder }}
            </option>
          }
          @for (option of optionsList; track option) {
            <option [value]="option.value">
              {{ option.label }}
            </option>
          }
        </select>
      </label>
    </div>
  `,
  standalone: false,
})
export class CartFunnelSelectBlockComponent implements OnInit, CartFunnelSelectBlockContract {
  readonly config = input<CartFunnelSelectBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    CartFunnelSelectBlockConfig,
    CartFunnelSelectBlockRuntimeConfig
  >(cartFunnelSelectBlockResolveConfig, () => ({ config: this.config() }));
  get title(): string {
    return this.resolvedConfig()['title'] as unknown as string;
  }
  get options(): any | undefined {
    return this.resolvedConfig()['options'] as unknown as any | undefined;
  }
  get required(): boolean {
    return this.resolvedConfig()['required'] as unknown as boolean;
  }
  get blockId(): string {
    return this.resolvedConfig()['block_id'] as unknown as string;
  }
  get formId(): string {
    return this.resolvedConfig()['form_id'] as unknown as string;
  }
  get displayTitleInComment(): boolean {
    return this.resolvedConfig()['display_title_in_comment'] as unknown as boolean;
  }
  get placeholder(): string | undefined {
    return this.resolvedConfig()['placeholder'] as unknown as string | undefined;
  }
  get radiusType(): 'SM' | 'MD' | 'LG' | 'FULL' {
    return this.resolvedConfig()['radius_type'] as unknown as 'SM' | 'MD' | 'LG' | 'FULL';
  }

  selectedItem: string = '0';
  optionsList: { value: string; label: string }[] = [];

  constructor(
    private cartFunnelDispatcher: CartFunnelStoreDispatcher,
    private readonly contentSelector: ContentStoreSelector,
  ) {}

  ngOnInit(): void {
    this.cartFunnelDispatcher.addValue({
      id: this.blockId,
      title: this.title,
      displayTitle: this.displayTitleInComment,
      formId: this.formId,
      required: this.required,
    });

    this.optionsList = [];

    for (let option of this.options) {
      this.contentSelector.selectBlock(option.block).subscribe(blockData => {
        if (blockData && blockData.data) {
          this.optionsList.push({
            //@ts-ignore
            value: blockData.data.value as string,
            //@ts-ignore
            label: blockData.data.label as string,
          });
        }
      });
    }
  }

  onValueChange(selectedItem?: string): void {
    this.cartFunnelDispatcher.updateValue({
      id: this.blockId,
      changes: {
        value: selectedItem,
      },
    });
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(CartFunnelSelectBlockComponent, { 'keyAliases': {} });
